/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import './Loader.css'

import { Box } from '@material-ui/core'
import React from 'react'
import ReactDOM from 'react-dom'
import { useTranslation } from 'react-i18next'
import Lottie from 'react-lottie'

import animationLoader from '../../assets/lotties/loader'

export default function Loader() {
  const [showMessage, setShowMessage] = React.useState(false)
  const { t } = useTranslation()

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationLoader,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  React.useEffect(() => {
    const timeOut = setTimeout(() => {
      setShowMessage(true)
    }, 5000)

    return () => {
      if (timeOut) {
        clearTimeout(timeOut)
      }
    }
  }, [])

  return ReactDOM.createPortal(
    <div id="loaderConteiner" className="loader-container">
      <div className="loader-icon">
        <Lottie options={defaultOptions} height={100} width={100} />
        {showMessage && (
          <Box
            fontWeight={500}
            component="span"
            mt={2}
            fontSize="14px"
            color="var(--color-blue-grey-5)"
          >
            {t('loaderWaitMessage')}
          </Box>
        )}
      </div>
    </div>,
    document.getElementById('loader')
  )
  // } else {
  //   return <div>12345</div>;
  // }
}
